var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface78562"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(15.686275%,37.64706%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 5.515625 2 C 3.585938 2 2 3.585938 2 5.515625 L 2 24.492188 C 2 26.414062 3.585938 28 5.515625 28 L 24.492188 28 C 26.414062 28 28 26.414062 28 24.492188 L 28 5.515625 C 28 3.585938 26.414062 2 24.492188 2 Z M 5.515625 4 L 24.492188 4 C 25.335938 4 26 4.664062 26 5.515625 L 26 24.492188 C 26 25.335938 25.335938 26 24.492188 26 L 5.515625 26 C 4.664062 26 4 25.335938 4 24.492188 L 4 5.515625 C 4 4.664062 4.664062 4 5.515625 4 Z M 8 6 C 6.898438 6 6 6.898438 6 8 C 6 9.101562 6.898438 10 8 10 C 9.101562 10 10 9.101562 10 8 C 10 6.898438 9.101562 6 8 6 Z M 6 12 L 6 24 L 10 24 L 10 12 Z M 12 12 L 12 24 L 16 24 L 16 18.640625 C 16 16.976562 16.15625 15.484375 18.15625 15.484375 C 20.125 15.484375 20 17.273438 20 18.75 L 20 24 L 24 24 L 24 18.078125 C 24 14.640625 23.28125 12 19.382812 12 C 17.507812 12 16.5625 12.75 16.046875 13.75 L 16 13.75 L 16 12 Z M 12 12 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.57ce5a795c038eecde21087777440919.svg";
export { ForwardRef as ReactComponent };